//

export const environment = {
  baseUrl: '',
  // baseUrl: 'https://api.en-sales-regional-platform.kisters.de',
  // baseUrl: 'http://en-sales-regional-platform.kisters.de:3003',
  // baseUrlApi: 'https://api.en-sales-regional-platform.kisters.de/api',
  baseUrlApi: '/api',
  // baseUrlApi: 'http://en-sales-regional-platform.kisters.de:3003/api',
  matomoTrackUser: true,
  matomoUrl: 'http://10.3.88.237/',
  matomoId: 1,
  production: false,
  mock: false
};
